/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import * as actionTypes from "./pageActionTypes";

export const savePageContext = (newContext) => {
  return {
    type: actionTypes.PAGE_CONTEXT_CHANGED,
    pageContext: newContext,
  };
};
